import { useState } from 'react';
import { flashFeed } from '@/mocks/feed';
import SectionHeading from '@/pages/home/components/SectionHeading';
import RankBoard from '@/pages/home/components/RankBoard';

const filters = ['全部', '娱乐圈', '网红圈', '饭圈', '资本'];

export default function FlashFeed() {
  const [active, setActive] = useState('全部');
  const [visible, setVisible] = useState(6);

  const list = active === '全部' ? flashFeed : flashFeed.filter((item) => item.channel === active);
  const shown = list.slice(0, visible);

  return (
    <section id="feed" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          kicker="Live Timeline"
          title="今日快讯 · 一条正在发生的时间线"
          description="按时间顺序记录每一条被核验的线索，不做情绪化结论，只呈现事件、时间与关联方。"
          linkHref="#deepdive"
          linkLabel="看深度拆解"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {filters.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => {
                setActive(item);
                setVisible(6);
              }}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-medium transition-colors ${
                active === item
                  ? 'bg-foreground-950 text-background-50'
                  : 'border border-background-300 bg-background-50 text-foreground-600 hover:border-foreground-300 hover:text-foreground-900'
              }`}
            >
              {item}
            </button>
          ))}
          <span className="ml-auto hidden items-center gap-2 self-center text-xs text-foreground-500 sm:flex">
            共 {list.length} 条线索
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="relative border-l border-background-300 pl-6 md:pl-8">
              {shown.map((item) => (
                <article key={item.id} className="relative pb-9 last:pb-0">
                  <span
                    className={`absolute -left-[31px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 md:-left-[39px] ${
                      item.hot ? 'border-primary-500 bg-primary-500' : 'border-background-300 bg-background-50'
                    }`}
                  />
                  <div className="flex flex-wrap items-center gap-3">
                    <time className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{item.time}</time>
                    <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {item.channel}
                    </span>
                    {item.hot ? (
                      <span className="flex items-center gap-1 rounded bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                        <i className="ri-fire-line text-xs" />
                        热议中
                      </span>
                    ) : null}
                    <span className="ml-auto flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-eye-line text-xs" />
                      热度 {item.heat}
                    </span>
                  </div>
                  <h3 className="mt-3 cursor-pointer font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors hover:text-primary-600 md:text-xl">
                    {item.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="mt-3 flex items-center gap-5 text-xs text-foreground-500">
                    <span className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600">
                      <i className="ri-bookmark-line text-sm" />
                      收藏
                    </span>
                    <span className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600">
                      <i className="ri-chat-3-line text-sm" />
                      讨论
                    </span>
                    <span className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600">
                      <i className="ri-share-forward-line text-sm" />
                      转发
                    </span>
                  </div>
                </article>
              ))}
            </div>

            {visible < list.length ? (
              <button
                type="button"
                onClick={() => setVisible((prev) => prev + 4)}
                className="mt-10 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-foreground-400 hover:bg-background-100"
              >
                <i className="ri-add-line text-base" />
                展开更多线索
              </button>
            ) : null}
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <RankBoard />
              <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-5">
                <p className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                  <i className="ri-shield-check-line text-base text-accent-600" />
                  我们如何核验线索
                </p>
                <ul className="mt-3 flex flex-col gap-2.5 text-xs leading-relaxed text-foreground-600">
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 text-sm text-primary-500" />
                    至少两个独立信源交叉确认
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 text-sm text-primary-500" />
                    保留原始材料与时间戳
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-circle-line mt-0.5 text-sm text-primary-500" />
                    结论与推测分段标注
                  </li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}